import { render, staticRenderFns } from "./ProjectCopyModal.vue?vue&type=template&id=983aef50&scoped=true&"
import script from "./ProjectCopyModal.vue?vue&type=script&lang=ts&"
export * from "./ProjectCopyModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCopyModal.vue?vue&type=style&index=0&id=983aef50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983aef50",
  null
  
)

export default component.exports